import { Type } from '@angular/core';

import { ComponentsShowcaseComponent } from './pages/components/components-showcase.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { CountryFlagComponent } from './pages/login/country-flag.component';
import { LoginComponent } from './pages/login/login.component';
import { MfaCodeComponent } from './pages/login/mfa-code.component';
import { VehicleHistoryDetailsDialogComponent } from './pages/vehicle-historic/dialogs/vehicle-history-details-dialog.component';
import { VehicleHistoricV2Component } from './pages/vehicle-historic/vehicle-historic-v2.component';
import { LoadingSpinnerComponent } from './shared/components/loading-spinner/loading-spinner.component';
import { PaginationComponent } from './shared/components/pagination/pagination.component';
import { PortalCardComponent } from './shared/components/portal-card/portal-card.component';

export const MIGRATED_COMPONENTS: Type<unknown>[] = [
  ComponentsShowcaseComponent,
  CountryFlagComponent,
  LoginComponent,
  MfaCodeComponent,
  VehicleHistoricV2Component,
  VehicleHistoryDetailsDialogComponent,
  LoadingSpinnerComponent,
  PaginationComponent,
  PortalCardComponent,
  DashboardComponent,
];

export interface DowngradeEntry {
  selector: string;
  component: Type<unknown>;
}

export const DOWNGRADES: DowngradeEntry[] = [
  { selector: 'appLogin', component: LoginComponent },
  { selector: 'appVehicleHistoricV2', component: VehicleHistoricV2Component },
  {
    selector: 'appVehicleHistoryDetailsDialog',
    component: VehicleHistoryDetailsDialogComponent,
  },
  { selector: 'appLoadingSpinner', component: LoadingSpinnerComponent },
  { selector: 'appPagination', component: PaginationComponent },
  { selector: 'appComponentsShowcase', component: ComponentsShowcaseComponent },
  { selector: 'appDashboard', component: DashboardComponent },
];
